import LabelProvider from "core/components/label/LabelProvider";
import { Completion } from "./CourseWrapper";
import { Course } from './../../../common/Labels/Course';

const provider = LabelProvider.create({
	...Course
});

export default provider;

const { NotStarted, Started, Incomplete, Completed, Passed, Failed } = provider.Labels;

export function completionLabel(completion: Completion): React.SFC {
	switch(completion) {
		case Completion.Started:
			return Started;
		case Completion.Incomplete:
			return Incomplete;
		case Completion.Completed:
			return Completed;
		case Completion.Passed:
			return Passed;
		case Completion.Failed:
			return Failed;
		case Completion.NotStarted:
		default:
			return NotStarted;
	}
}



// WEBPACK FOOTER //
// ./src/common/entities/courseWrapper/labels.ts